import React from 'react';
import Button from '@material-ui/core/Button';
import { PropTypes } from 'prop-types';

// Parametros props
//id: Id del componente
//title: titulo del acordeón
//className: posición del botón 
//startIcon: icono en React
//color: color del botón
//loading: variable si el botón esta cargando o esta disponible
//onClick: funcion del botón

Boton.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  startIcon: PropTypes.element,
  color: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  onClick: PropTypes.func
};

Boton.defaultProps = {
  id: 'Custom',
  title: "Guardar",
  className: "",
  startIcon: <></>,
  color: '#00549F',
  loading: false,
  onClick: () => { }
}

function Boton(props) {
  return (<>
    <Button
      id={props.id}
      className={props.className}
      style={{ backgroundColor: props.color, marginTop: 13, color: '#ffff', borderRadius: '3px', textTransform: 'none', padding: 8 }}
      startIcon={props.startIcon}
      endIcon={props.endIcon}
      onClick={props.onClick}
      variant="contained" >
      {props.children || props.title}
    </Button>
  </>)
}

export default React.memo(Boton);
